
import { BaseEntity } from "@app/common";
import { Column, Display, TableColumnType } from "@messaia/cdk";
import { PhoneNumberPortingStatus } from "../enums/phone-number-porting-status";
import { PhoneNumberStatus } from "../enums/phone-number-status";

export class PhoneNumber extends BaseEntity {
	/**
	 * @property
	 */
	public id: number;

	/**
	 * @property
	 */
	public countryCode: string;

	/**
	 * @property
	 */
	@Column({
		type: TableColumnType.TextInput,
		maxWidth: 110,
		disable: (row: PhoneNumber) => row.portingStatus == PhoneNumberPortingStatus.Confirmed
	})
	@Display($localize`:@@phoneNumberPrefix:Phone number prefix`)
	public nationalDestinationCode: string;

	/**
	 * @property
	 */
	@Column({
		type: TableColumnType.TextInput,
		maxWidth: 120,
		disable: (row: PhoneNumber) => row.portingStatus == PhoneNumberPortingStatus.Confirmed
	})
	@Display($localize`:@@subscriberNumber:Subscriber number`)
	public subscriberNumber: string;

	/**
	 * @property
	 */
	@Column({ enumType: PhoneNumberStatus, showGtSm: true })
	@Display($localize`:@@status:Status`)
	public status: PhoneNumberStatus = PhoneNumberStatus.Pending;

	/**
	 * @property
	 */
	@Column({ enumType: PhoneNumberPortingStatus, showGtSm: true })
	@Display($localize`:@@portingStatus:Porting status`)
	public portingStatus: PhoneNumberPortingStatus = PhoneNumberPortingStatus.New;

	/**
	 * constructor
	 * @param init 
	 */
	public constructor(init?: Partial<PhoneNumber>) {
		super(init)
		Object.assign(this, init);
	}
}